import { useMutation, useQueryClient } from 'react-query'
import { API_METHODS } from 'constants/api-methods'
import { BASE_API_URL } from 'constants/env'
import { ID } from 'utils/types'
import { store } from 'index'
import { apiHeaders } from 'utils/api-headers'
import { UserOrganization } from 'interfaces/user-organization'
import { handleErrorsAndJSON } from 'utils/handle-errors'
import { userOrganizationsKeys } from 'utils/query-keys'
import toast from 'react-hot-toast'

const useUpdateUserOrganization = (orgId: ID) => {
  const queryClient = useQueryClient()

  const updateUserOrganization = async (isAdmin: boolean, userOrgId: ID) => {
    const response = await fetch(
      `${BASE_API_URL}/admin/api/v2/user_organizations/${userOrgId}`,
      {
        method: API_METHODS.PUT,
        headers: apiHeaders(store.getState()),
        body: JSON.stringify({ is_admin: isAdmin }),
      }
    )
    return handleErrorsAndJSON(response)
  }

  return useMutation(
    ({ isAdmin, userOrgId }: { isAdmin: boolean; userOrgId: ID }) =>
      updateUserOrganization(isAdmin, userOrgId),
    {
      onSettled: () => {
        queryClient
          .invalidateQueries(userOrganizationsKeys.detail(orgId))
          .catch(console.error)
      },
      onError: (error: any, variables, context) => {
        console.error('Update user organization error:', error)

        // Check if the error is related to active Texting Betty integration
        if (
          error?.message?.includes('Texting Betty') ||
          error?.error?.messages?.some((msg: string) =>
            msg.includes('Texting Betty')
          )
        ) {
          const errorMessage =
            error.message ||
            error?.error?.messages?.[0] ||
            'User has active Texting Betty integration.'

          toast.error(errorMessage, {
            duration: 5000,
            icon: '⚠️',
          })
        } else {
          // Generic error handling
          const errorMessage =
            error.message ||
            error?.error?.messages?.[0] ||
            'Failed to update user.'

          toast.error(errorMessage, {
            duration: 4000,
            icon: '❌',
          })
        }
      },
    }
  )
}

export default useUpdateUserOrganization
